import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const currentHolder = event.detail.data.holder || event.target.closest('.shopify-section, dialog');
  if (!currentHolder) return;

  const currentBadge = currentHolder.querySelector('[data-trending-badge-container]');
  const updatedBadge = event.detail.data.html.querySelector('[data-trending-badge-container]');

  if (currentBadge && updatedBadge) {
    morph(currentBadge, updatedBadge, { childrenOnly: true });
  }
});